import { useState, useEffect, useCallback, useRef } from 'react';

/**
 * Debounce a value. Useful for search inputs (e.g. 300–500ms).
 */
export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
